import classnames from 'classnames';
import * as React from 'react';
import eurasiaTruck from '../../assets/img/eurasia-truck.png';
import './eurasia-truck.less';


interface IEurasiaLogoProps {
    width?: number
    single?: boolean
    className?: any
}

const EurasiaTruck = ({ width, single, className }: IEurasiaLogoProps) => {
    return (
        <div className={classnames('eurasia-truck', className)}>
            <img alt="Eurasia Trucker" src={eurasiaTruck} width={width}/>
        </div>
    );
};

export default EurasiaTruck;
